<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="bg-white space-y-20 text-hdb fsec selection:">
    <div
      class="w-full h-screen bg-no-repeat bg-cover bg-center flex flex-col items-center justify-between overflow-hidden" style="
      background-image: url('https://cloud.appwrite.io/v1/storage/buckets/64b65db5e9e19d965545/files/64d0432eac2d6ef47d8e/view?project=64b65dae294f5f63832e');"
    >
      <!--PC Header-->
      <div class="hidden w-full pl-3 pr-8 py-4 sm:flex flex-row items-center justify-between">
        <img src="@/assets/logos/full.png" alt="" class="w-32">
        <div class="flex flex-row items-center font-bold space-x-4">
          <a href="#services">Servicios</a>
          <a href="#types">Estrategias</a>
          <a href="#process">Proceso</a>
          <a href="#stats">Métricas</a>
          <a href="https://wa.me/51906610586?text= Quisiera agendar una consultoría gratuita para mi negocio!" class="bg-hdb text-white px-4 py-2 rounded-full transition-all hover:ring hover:ring-hdb hover:ring-offset-4 hover:ring-offset-hdy">Consultoría Gratis</a>
        </div>
      </div>
      <!--PC Banner-->
      <Tilt class="hidden sm:flex flex-col items-center justify-center w-[60%]" :options="this.options">
        <img style="transform: translateY(55px)" class="w-full" src="https://cloud.appwrite.io/v1/storage/buckets/64b65db5e9e19d965545/files/64d132a7d4b94fd7f536/view?project=64b65dae294f5f63832e" alt="">
      </Tilt>

      <!--Mobile header-->
      <div class="w-full pl-3 pr-8 py-4 flex sm:hidden flex-row items-center justify-center">
        <img src="@/assets/logos/full.png" alt="" class="w-32">
      </div>
      <div class="flex sm:hidden flex-col items-center justify-center w-[100%]" :options="this.options">
        <img class="w-full" src="https://cloud.appwrite.io/v1/storage/buckets/64b65db5e9e19d965545/files/64d214844c5135bfbea3/view?project=64b65dae294f5f63832e" alt="">
      </div>
    </div>

    <!-- Services -->
    <div id="services" class="mx-auto max-w-[88rem] sm:px-6 lg:px-8">
      <h1 class="fmain text-center text-4xl">Así es como podemos ayudarte</h1>
      <p class="fsec text-center">¿Qué necesita tu negocio?</p>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-14 mt-8">
        <button class="border rounded-md py-8 px-4 flex flex-col items-center justify-center space-y-4 hover:shadow-lg transition-all">
          <div class="rounded-md bg-hdy p-1">
            <!-- <i :class="`fa-solid fa-money-bill text-white text-4xl`"/> -->
            <img src="@/assets/images/socials.svg" class="w-16" alt="">
          </div>
          <!-- <h2 class="fmain text-xl">{{ i.title }}</h2> -->
          <h2 class="fmain text-xl">
            <span class="block">Ventas</span>
            <span class="fsec text-lg">
              <span class="block">
                En el mundo digital, 
                <span class="text-hdy font-bold">si no apareces, no cuentas.</span>
              </span>
              <span class="block">Nuestros analistas certificados se encargarán de generarte clientes potenciales para que <span class="text-hdy font-bold">solamente cierres la venta.</span></span>
            </span>
          </h2>
        </button>
        <button class="border rounded-md py-8 px-4 flex flex-col items-center justify-center space-y-4 hover:shadow-lg transition-all">
          <div class="rounded-md bg-hdy p-4">
            <i :class="`fa-solid fa-sparkles text-white text-4xl`"/>
          </div>
          <!-- <h2 class="fmain text-xl">{{ i.title }}</h2> -->
          <h2 class="fmain text-xl">
            <span class="block">Identidad Online</span>
            <span class="fsec text-lg">
              <span class="block">
                No se trata de conseguir más likes o corazones. Analizamos tu marca, encontramos tu audiencia y creamos <span class="text-hdy font-bold">comunicación efectiva</span> para lograr el correcto objetivo en cada red social donde debes estar
              </span>
            </span>
          </h2>
        </button>
      </div>
    </div>

    <!-- Types -->
    <div id="types" class="w-full bg-hdy">
      <div class="mx-auto max-w-[88rem] pt-1 sm:px-6 lg:px-8">
        <!--Desktop-->
        <div class="hidden md:grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
          <button class="py-8 px-4 flex flex-col items-center justify-center space-y-4">
            <div class="rounded-md bg-white p-4 flex items-center">
              <i :class="`fa-solid fa-users text-hdy text-4xl`"/>
            </div>
            <h2 class="fmain text-xl">
              <span class="block">¡Más clientes!</span>
              <span class="fsec text-lg">Te conseguimos más clientes y hacemos que te compren más veces</span>
            </h2>
          </button>
          <div class="flex flex-col items-center justify-end">
            <img src="https://cloud.appwrite.io/v1/storage/buckets/64b65db5e9e19d965545/files/64d21f8a38231eff6c5e/view?project=64b65dae294f5f63832e&mode=admin" alt="" >
          </div>
          <button class="py-8 px-4 flex flex-col items-center justify-center space-y-4">
            <div class="rounded-md bg-white p-4 flex items-center">
              <i :class="`fa-solid fa-chart-line-up text-hdy text-4xl`"/>
            </div>
            <h2 class="fmain text-xl">
              <span class="block">¡Más valor!</span>
              <span class="fsec text-lg">Te ayudamos a subir tus precios mejorando la percepción de tu marca.</span>
            </h2>
          </button>
        </div>
        <!--Mobile-->
        <div class="md:hidden grid grid-cols-2 gap-4 mt-8">
          <button class="py-8 px-4 flex flex-col items-center justify-between space-y-4">
            <div class=" aspect-square rounded-md bg-white p-4 flex items-center">
              <i :class="`fa-solid fa-users text-hdy text-4xl`"/>
            </div>
            <h2 class="fmain text-xl">
              <span class="block">¡Más clientes!</span>
              <span class="fsec text-lg">Te conseguimos más clientes y hacemos que te compren más veces</span>
            </h2>
          </button>
          <button class="aspect-square  py-8 px-4 flex flex-col items-center justify-between space-y-4">
            <div class="rounded-md bg-white p-4">
              <i :class="`fa-solid fa-chart-line-up text-hdy text-4xl`"/>
            </div>
            <h2 class="fmain text-xl">
              <span class="block">¡Más valor!</span>
              <span class="fsec text-lg">Te ayudamos a subir tus precios mejorando la percepción de tu marca.</span>
            </h2>
          </button>
          <div class="flex flex-col items-center justify-end col-span-2">
            <img src="https://cloud.appwrite.io/v1/storage/buckets/64b65db5e9e19d965545/files/64d21f8a38231eff6c5e/view?project=64b65dae294f5f63832e&mode=admin" alt="" >
          </div>
        </div>
      </div>
    </div>

    <!-- Process -->
    <div id="process" class="mx-auto max-w-[88rem] sm:px-6 lg:px-8">
      <h1 class="fmain text-center text-4xl">Te contamos como lo hacemos</h1>
      <!-- <p class="fsec text-center">Te contamos como lo hacemos</p> -->
      <div class="grid grid-cols-1 sm:grid-cols-3 px-20 gap-0 sm:px-0 sm:gap-14 mt-8">
        <img src="@/assets/images/Fase1.svg" class="hover:border-4 rounded-lg hover:border-hdy transition-all" alt="">
        <img src="@/assets/images/Fase2.svg" class="hover:border-4 rounded-lg hover:border-hdy transition-all" alt="">
        <img src="@/assets/images/Fase3.svg" class="hover:border-4 rounded-lg hover:border-hdy transition-all" alt="">
      </div>
    </div>

    <!-- Stats -->
    <div id="stats" class="mx-auto max-w-[88rem] sm:px-6 lg:px-8">
      <h1 class="fmain text-center text-4xl">Nuestra experiencia</h1>
      <p class="fsec text-center">Estos son algunos números</p>
      <div class="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-14 mt-8">
        <button v-for="(i, index) in stats" :key="index" class="border rounded-md py-8 px-4 flex flex-col items-center justify-center space-y-4 hover:shadow-lg transition-all">
          <div class="rounded-md bg-hdy p-4">
            <i :class="`fa-solid fa-${i.icon} text-white text-4xl`"/>
          </div>
          <h2 class="fmain text-xl">
            <span class="block">{{ i.stat }}</span>
            <span class="fsec text-lg">{{ i.description }}</span>
          </h2>
        </button>
      </div>
    </div>

    <!--CTA-->
    <div id="cta" class="mx-auto max-w-[88rem] sm:px-6 lg:px-8">
      <h1 class="fmain text-center text-4xl">Elige un tipo de cita</h1>
      <!-- <p class="fsec text-center">Te mostramos como lo hacemos</p> -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-14 mt-8">
        <div
          class="w-full h-auto bg-no-repeat bg-cover bg-center
            flex flex-row items-center justify-between px-6 pt-6
            overflow-hidden
            rounded-md
          "
          style=" background-image: url('https://cloud.appwrite.io/v1/storage/buckets/64b65db5e9e19d965545/files/64d0432eac2d6ef47d8e/view?project=64b65dae294f5f63832e');"
        >
          <!-- <i class="fa-solid fa-compass text-white text-9xl"></i> -->
          <img src="https://cloud.appwrite.io/v1/storage/buckets/64b65db5e9e19d965545/files/64d2216e78e55be490e4/view?project=64b65dae294f5f63832e&mode=admin" class="w-[34%]" alt="">
          <div class="flex flex-col items-end space-y-2">
            <h1 class="text-right">
              <span class="block text-2xl font-bold">¿Necesitas que te guiemos?</span>
              <span class="block">Te regalarmos <span class="texhdy font-bold underline">20 minutos</span> de consultoría</span>
            </h1>
            <a href="https://wa.me/51906610586?text= Quisiera agendar una consultoría gratuita para mi negocio!" class="bg-hdb text-white px-4 hover:px-8 py-2 rounded-full transition-all">Consultoría Gratis</a>
          </div>
        </div>
        <div
          class="w-full h-auto bg-no-repeat bg-cover bg-center
            flex flex-row items-center justify-between px-6 pt-6 scroll-pb-8
            overflow-hidden
            rounded-md
          "
          style=" background-image: url('https://cloud.appwrite.io/v1/storage/buckets/64b65db5e9e19d965545/files/64d0432eac2d6ef47d8e/view?project=64b65dae294f5f63832e');"
        >
          <!-- <i class="fa-solid fa-list-check text-white text-9xl"></i> -->
          <div class="h-full w-[45%] flex flex-col justify-end">
            <img src="https://cloud.appwrite.io/v1/storage/buckets/64b65db5e9e19d965545/files/64d22303afe7179567dd/view?project=64b65dae294f5f63832e&mode=admin" alt="">
          </div>
          <div class="flex flex-col items-end space-y-2">
            <h1 class="text-right">
              <span class="block text-2xl font-bold">¿Ya sabes lo que necesitas?</span>
              <span class="block">Reunámonos y <span class="texhdy font-bold underline">revisemos</span> lo que tu marca nececita</span>
            </h1>
            <a href="https://wa.me/51906610586?text= Quiero agendar una reunión para revisar lo que mi marca necesita!" class="bg-hdb text-white px-4 hover:px-8 py-2 rounded-full transition-all">Agenda para cotizar</a>
          </div>
        </div>
      </div>
    </div>


    <footer class="bg-white">
      <div class="mx-auto max-w-7xl overflow-hidden py-12 px-4 sm:px-6 lg:px-8">
        <img src="@/assets/logos/gray.png" alt="" class="w-32 opacity-40 m-auto mb-2">
        <!-- <nav class="-mx-5 -my-2 flex flex-wrap justify-center" aria-label="Footer">
          <div v-for="item in navigation.main" :key="item.name" class="px-5 py-2">
            <a :href="item.href" class="text-base text-gray-500 hover:text-gray-900">{{ item.name }}</a>
          </div>
        </nav> -->
        <div class="mt-8 flex justify-center space-x-6">
          <a href="https://www.facebook.com/profile.php?id=100095674650559" class="text-gray-400 hover:text-gray-500">
            <span class="sr-only">Facebook</span>
            <i class="fa-brands fa-facebook text-xl"></i>
          </a>
          <a href="https://www.instagram.com/heroesdigitales.pe" class="text-gray-400 hover:text-gray-500">
            <span class="sr-only">Instagram</span>
            <i class="fa-brands fa-instagram text-xl"></i>
          </a>
          <a href="https://wa.me/51906610586" class="text-gray-400 hover:text-gray-500">
            <span class="sr-only">WhatsApp</span>
            <i class="fa-brands fa-whatsapp text-xl"></i>
          </a>
        </div>
        <p class="mt-8 text-center text-base text-gray-400">&copy; 2023 Héroes Digitales</p>
      </div>
    </footer>
  </div>

</template>

<script>
import Tilt from 'vanilla-tilt-vue'

export default {
  data() {
    return {
      navigation: {
        main: [
          { name: 'About', href: '#' },
          { name: 'Blog', href: '#' },
          { name: 'Jobs', href: '#' },
          { name: 'Press', href: '#' },
          { name: 'Accessibility', href: '#' },
          { name: 'Partners', href: '#' },
        ],
      },
      options: {
        gyroscope: true,
        reverse: true,
        easing: "cubic-bezier(.03,.98,.52,.99)",
        max: 8,
      },
      services: [
        {
          icon: 'house',
          title: 'Ventas',
          description: 'En el mundo digital, si no apareces, no cuentas. Nuestros analistas certificados de Facebook(Meta) Ads se encargarán de generarte clientes potenciales para que solamente cierres la venta.'
        },
        {
          icon: 'house',
          title: 'Social Media',
          description: 'Campañas exitosas'
        }
      ],
      stats: [
        {
          icon: 'money-bill-trend-up',
          stat: '> S/120 000',
          description: 'Invertidos'
        },
        {
          icon: 'toolbox',
          stat: '> 48',
          description: 'Campañas exitosas'
        },
        {
          icon: 'user-group',
          stat: '> 12',
          description: 'Clientes atendidos'
        },
        {
          icon: 'can-food',
          stat: '> 36',
          description: 'Monster bebidos'
        },
      ]
    }
  },
  methods: {},
  components: {
    Tilt
  },
}

</script>

<style>
::-webkit-scrollbar {
    display: none;
}
</style>